import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { TexttemplateModel } from 'projects/core/src/lib/models/texttemplate.model';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { SelectItem } from 'primeng/api';
import { TEXT_TYPES } from 'projects/core/src/lib/constants';

@Component({
  selector: 'app-texttemplate-basedata',
  templateUrl: './texttemplate-basedata.component.html',
  styleUrls: ['./texttemplate-basedata.component.scss']
})
export class TexttemplateBasedataComponent extends BaseForm implements OnInit, OnChanges {

  @Input() texttemplate: TexttemplateModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public optionsTypes: Array<SelectItem> = [];
  public form = this.fb.group({
    identifier: new UntypedFormControl({ value: '', disabled: true }),
    type: new UntypedFormControl({ value: '', disabled: true }),
    description: new UntypedFormControl(''),
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.optionsTypes = FormHelper.getSelectList(TEXT_TYPES, null, this.transloco);
    this.ui.setFocus();
  }

  ngOnChanges(): void {
    this.items = [];
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('texttemplates', this.texttemplate.id, this.form.value).subscribe({
        next: (result: any) => {
          this.texttemplate.deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.texttemplate.identifier }), this.transloco.translate('common.saved'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  protected startEdit(): void {
    if (this.texttemplate !== null) {
      this.form.patchValue({
        identifier: this.texttemplate.identifier,
        type: this.texttemplate.type,
        description: this.texttemplate.description,
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

}
